import React, { useEffect, useState } from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Footer } from "../../Footer";
import { Button, Col, Form, Row } from "react-bootstrap";
import * as icons from "react-bootstrap-icons";
import {
  GetNotificationMes,
  GetNotificationMesData,
  NotificationReg,
} from "../../redux/auth-reducer/auth-service";
import { ModalBox } from "../Outer/Modal";
import { ToastContainer, toast } from "react-toastify";
import dayjs from "dayjs";
import { readApiMessage } from "../../utils/helper/helper";

export const Admin_notification = () => {
  const [data, setData] = useState(false);
  const [notificationMes, setNotificationMes] = useState([]);
  const [showView, setShowView] = useState(false);
  const [validated, setValidated] = useState(false);
  const [count, setCount] = useState(0);
  const [itemData, setItemData] = useState([]);
  const [itemLastData, setItemLastData] = useState([]);
  const [notificationsPerPage] = useState(7);
  const [activePage, setActivePage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const pageOptions = [10, 20, 30, 50];
  const [notificationReg, setNotificationReg] = useState({
    message: "",
  });
  const sidebarfun = () => {
    setData(!data);
  };
  const viewFn = (viewItem) => {
    setShowView(true);
  };

  const getDetails = localStorage?.getItem("role");

  // useEffect(() => {

  //     const NotificationMessageFun = async () => {
  //         await GetNotificationMes().then((response) => {

  //             setNotificationMes(response?.data?.dataList);
  //         })
  //     }
  //     NotificationMessageFun();

  // }, [count])

  const NotificationMessageFun = async (data) => {
    try {
      const response = await GetNotificationMesData(data); // Call your API function

      setNotificationMes(response?.data?.dataList || []); // Set the item list
      setTotalRows(response?.data?.totalPageSize || 0); // Set the total number of rows
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    NotificationMessageFun(data); // Fetch data when currentPage changes
  }, [currentPage, count]);

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    NotificationMessageFun(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  const indexOfLastNotification = currentPage * notificationsPerPage;
  const indexOfFirstNotification =
    indexOfLastNotification - notificationsPerPage;
  const currentNotifications = notificationMes?.slice(
    indexOfFirstNotification,
    indexOfLastNotification
  );

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    setActivePage(pageNumber);
  };
  // const totalPages = Math.ceil(notificationMes?.length / notificationsPerPage);

  const handleClosed = () => {
    setShowView(false);
    setValidated(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (notificationReg?.message == "") {
      return setValidated(true);
    }
    const registerData = {
      message: notificationReg?.message,
    };
    await NotificationReg(registerData).then((res) => {
      // A failure has a body too. Success is the NotificationData that was stored, which has an
      // `id` and no `status` member; a failure body (a 500's ErrorDetails, a 400) has no `id`.
      if (typeof res?.id === "number") {
        setCount(count + 1);
        setShowView(false);
        toast.success("Success");
        setValidated(false);
      } else {
        toast.error(readApiMessage(res));
      }
    });
  };

  const heandelChange = (e) => {
    setNotificationReg({
      ...notificationReg,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    notificationMes?.map((item) => {
      var user = getDetails.split(" ");
      var dataList = user?.[0];
      var dataList2 = user?.[1];
      var listItem = dataList.charAt(0);
      var listItem2 = dataList2.charAt(0);
      setItemData(listItem);
      setItemLastData(listItem2);
    });
  }, [notificationMes]);

  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row className="d-flex align-items-center">
            <Col md={6}>
              <h1 className="heading-dash">Notification</h1>
            </Col>
            <Col md={6} className="text-right">
              <Button
                className="primary button-create-auction btn btn-primary "
                onClick={() => viewFn()}
              >
                <icons.Plus class="icon-plus" /> Broadcast Message
              </Button>
            </Col>
          </Row>
          <div className="group_data_table">
            <div className="notification_box">
              {currentNotifications?.map((ele) => (
                <div className="notification p-2" key={ele.id}>
                  <div className="notification-right">
                    <div className="profile-pic2">
                      {itemData} {itemLastData}
                    </div>
                    <div className="ms-3 notification-area">
                      <h1>{getDetails}</h1>
                      <div className="noti-msg">{ele?.message}</div>

                      <div className="Notification-Date">
                        {dayjs(ele?.createDate + "Z").format(
                          "MM/DD/YYYY hh:mm:ss A"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {/* Pagination Controls */}
              {totalRows > 1 && (
                <Row>
                  <Col md={12} className="text-right">
                    <div className="pagination-controls">
                      <>
                        <label>Rows per page: </label>{" "}
                        <select
                          id="itemsPerPage"
                          value={perPage}
                          onChange={handlePerPageChange}
                        >
                          {pageOptions.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </>

                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        <icons.ArrowLeft></icons.ArrowLeft>
                      </Button>
                      <span>
                        {" "}
                        {currentPage} of {totalRows}{" "}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage >= Math.ceil(totalRows)}
                      >
                        <icons.ArrowRight></icons.ArrowRight>
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
        <div className={data ? "Footer" : "footer-content"}>
          <Footer />
        </div>
      </div>

      <ModalBox
        show={showView}
        title={
          <>
            <h1 className="heading-dash">Add Broadcast Message</h1>
          </>
        }
        body={
          <>
            <Row>
              <Col>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                  <Row className="mb-3">
                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                      <Form.Label>Message</Form.Label>
                      <Form.Control
                        required
                        as="textarea"
                        name="message"
                        rows={3}
                        onChange={heandelChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter Message.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Col md={6}></Col>
                    <Col md={6} className="text-right">
                      <Button
                        type="button"
                        className="btn-Cancel secondary  me-3 mb-3"
                        onClick={handleClosed}
                      >
                        Cancel
                      </Button>
                      <Button type="submit" className="btn-Save  mb-3">
                        Post
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </>
        }
      />
    </>
  );
};
